import { EdgeUploadIdentityDocumentRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { UploadIdentityDocument } from '@/modules/auth/use-cases'

export function makeUploadIdentityDocument(): UploadIdentityDocument {
  return new EdgeUploadIdentityDocumentRepository(makeSupabaseEdgeHttpClient()).execute
}
